import React from 'react';
import _ from 'lodash';
import { getObjectID } from '@/services/algolia';
import { trpc } from '@/utils/trpc';

interface RankingScoreProps {
  media: {
    type: string;
    id: number;
    score?: number;
  };
}

export default function RankingScore({ media }: RankingScoreProps) {
  const { data: rankingData } = trpc.iq.getRankingScore.useQuery(
    {
      objectId: getObjectID(media.type as 'clips' | 'photo' | 'video', media.id),
    },
    {
      enabled: !media.score, // Only fetch if score is not provided
    }
  );

  const score = media.score ?? rankingData?.score ?? 0;

  return (
    <div className="absolute bottom-0 left-0 bg-white text-orange-500 rounded-lg px-2 py-1 m-4 z-10">
      <p>{_.round(score, 0)}</p>
    </div>
  );
}
